
import React from 'react'

import { Box, Grid, Step } from '@mui/material'
import { GridStepper } from '@front/squirtle'

import FormHeader from '@abra/elements/headers/Form'
import GroupTab from '@abra/panels/Tab/Group'

import PrimarySection from './Section/Primary'
import ContactSection from './Section/Contact'
import FinnancialSection from './Section/Finnancial'
import HistorySection from './Section/History'

const Group = ({ isManagingRecord, ...props }) =>
  <Box sx={{ display: 'flex', justifyContent: 'center' }} px={6}>
    <Grid container rowSpacing={3}>
      <Grid size={12}> <GroupTab /> </Grid>
      <Grid size={12}><FormHeader goBackPath={'/adherent'} /></Grid>
      <Grid size={12}>
        <GridStepper groupsCount={[4]} activeStep={0} orientation="vertical" getStepProps={index => ({ active: (index !== 3 && index !== 2) || !!isManagingRecord })}>
          <Step> <PrimarySection /> </Step>
          <Step> <FinnancialSection /> </Step>
          <Step> <ContactSection /> </Step>
          <Step> <HistorySection /> </Step>
        </GridStepper>
      </Grid>
    </Grid>
  </Box>

export default React.memo(Group)
